import { cn } from "@/shared/lib/utils";
import type { ChatSala } from "@/shared/hooks/useChatOperacional";
import { inferirTipoVinculoSala } from "@/shared/hooks/useChatOperacional";
import { Badge } from "@/shared/components/ui/badge";
import { corBadgeChatVinculo, labelChatVinculo } from "./chatOperacionalVinculo";

interface ChatSalaItemProps {
  sala: ChatSala;
  selected: boolean;
  tempoRelativo: string;
  onSelect: () => void;
}

export default function ChatSalaItem({ sala, selected, tempoRelativo, onSelect }: ChatSalaItemProps) {
  const tipo = inferirTipoVinculoSala(sala);
  const cores = corBadgeChatVinculo(tipo);
  const encerrada = sala.status === "encerrada";

  const temNaoLidas = (sala.nao_lidas ?? 0) > 0;

  return (
    <button
      type="button"
      onClick={onSelect}
      className={cn(
        "group relative w-full text-left rounded-lg border px-2.5 py-2 transition-all overflow-hidden",
        selected
          ? "border-[#791614]/30 bg-white shadow-sm"
          : "border-[#a9abae]/25 bg-white/60 hover:bg-white hover:border-[#d7b369]/45",
        encerrada && "opacity-60",
      )}
    >
      <span
        className={cn(
          "absolute left-0 top-0 h-full w-[3px] rounded-r bg-[#791614] transition-opacity",
          selected ? "opacity-100" : "opacity-0 group-hover:opacity-40",
        )}
        aria-hidden
      />
      <div className="flex items-start justify-between gap-1 mb-1">
        <span
          className={cn(
            "text-xs line-clamp-2 font-body",
            temNaoLidas || selected ? "font-semibold text-[#791614]" : "font-medium text-foreground",
          )}
        >
          {sala.titulo}
        </span>
        {temNaoLidas && (
          <Badge className="shrink-0 h-5 min-w-[20px] px-1 justify-center bg-destructive text-destructive-foreground text-[10px] ring-2 ring-[#f9f6f0]">
            {sala.nao_lidas! > 9 ? "9+" : sala.nao_lidas}
          </Badge>
        )}
      </div>
      <div className="flex items-center gap-1 flex-wrap mb-1">
        <span
          className={cn(
            "text-[9px] font-accent uppercase tracking-wider px-1.5 py-0 rounded border",
            cores.bg,
            cores.text,
            cores.border,
          )}
        >
          {labelChatVinculo(tipo)}
        </span>
        <span className="text-[10px] text-muted-foreground font-body">{tempoRelativo}</span>
      </div>
      {sala.ultima_mensagem && (
        <p
          className={cn(
            "text-[10px] line-clamp-2 font-body",
            temNaoLidas ? "text-foreground/80" : "text-muted-foreground",
          )}
        >
          {sala.ultima_mensagem}
        </p>
      )}
    </button>
  );
}
